/**
 * @generated SignedSource<<edc7d68b5f6f686f31d1b2e0cfc9c75d>>
 * @relayHash 1ddb7206934ab3dcd1cf0292ff839f9d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ddbf791d2d018cacdc833e0d1652f1d86228e3ac6814a7974f843771169ae3ee

import type { ConcreteRequest, Query } from 'relay-runtime';
export type ForgeDeprecationMessage_appQuery$variables = {
  id: string;
};
export type ForgeDeprecationMessage_appQuery$data = {
  readonly app: {
    readonly name: string;
  } | null | undefined;
};
export type ForgeDeprecationMessage_appQuery = {
  response: ForgeDeprecationMessage_appQuery$data;
  variables: ForgeDeprecationMessage_appQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "name"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "ForgeDeprecationMessage_appQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "App",
        "kind": "LinkedField",
        "name": "app",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ForgeDeprecationMessage_appQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "App",
        "kind": "LinkedField",
        "name": "app",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "ScalarField",
            "name": "id"
          }
        ]
      }
    ]
  },
  "params": {
    "id": "ddbf791d2d018cacdc833e0d1652f1d86228e3ac6814a7974f843771169ae3ee",
    "metadata": {},
    "name": "ForgeDeprecationMessage_appQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "06c66e4e27413d7a6996129034e23a82";

export default node;
